<template>
  <div :class="$i18n.locale">
    <div class="container">
      <div class="py-5 pb-1 text-center">
        <h1>{{ $t("profile.quoteData") }}</h1>
      </div>
      <div class="my-2" v-if="quotations">
        <b-button
          variant="outline-success"
          v-if="quotations.currency_based_price"
          id="show-btn"
          @click="$bvModal.show('bv-modal-example')"
        >
          {{ $t("profile.offer") }}
        </b-button>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-12 mb-5 pt-0 mt-0">
          <div class="d-flex justify-content-around align-items-center">
            <b-button
              class="mt-3 mx-1"
              variant="outline-success"
              block
              @click="addToCart(quotations)"
              v-if="add_to_cart == true && quotations && quotations.expiry_at"
            >
              {{ $t("cart.addToCart") }}
            </b-button>
          </div>
        </div>
        <div class="col-12 mb-2">
          <span
            v-if="loadingMainData"
            class="d-flex justify-content-center align-items-center"
          >
            <span>
              <spinner />
            </span>
          </span>
          <div class="new-design" v-if="sortedComments.length">
            <div class="chat-holder">
              <ul class="chat row">
                <!-- Use sortedComments instead of inline sorting -->
                <li
                  :class="{
                    'col-sm-12': quotate.comment_by == 'supplier',
                    'col-sm-6 offset-sm-6 ': quotate.comment_by == 'client',
                  }"
                  v-for="(quotate, index) in sortedComments"
                  :key="
                    quotate.order ||
                    quotate.order_id ||
                    quotate.created_at ||
                    index
                  "
                >
                  <p
                    :class="{
                      'left w-50': quotate.comment_by == 'supplier',
                      'right w-100': quotate.comment_by == 'client',
                    }"
                  >
                    <span
                      v-if="quotate.comment_by == 'supplier'"
                      class="main-color"
                    >
                      <span v-if="quotations.supplier.company_name">{{
                        quotations.supplier.company_name
                      }}</span>
                      <span v-else>{{
                        quotations.supplier.company_name_en
                      }}</span>
                    </span>
                    <span v-if="quotations.client" class="main-color">
                      <span v-if="quotations.client">
                        {{ quotations.client.first_name }}
                        {{ quotations.client.last_name }}
                      </span>
                      <span v-if="quotate.comment_by === 'supplier'">
                        {{ quotations.supplier.company_name }}
                      </span>
                    </span>
                    <span
                      class="message comment"
                      v-if="quotate.comment"
                      v-html="decodeComment(quotate.comment)"
                    ></span>
                    <span class="messageDate">{{
                      quotate.created_at | formatDate
                    }}</span>
                  </p>
                </li>
              </ul>
              <div class="my-5 sendMessageHolder" v-if="quotations">
                <div class="row justify-content-center align-content-center">
                  <div class="col-md-9 col-sm-9 mb-2">
                    <div class="input-holder">
                      <input
                        v-model="message"
                        type="text"
                        class="form-control"
                        :placeholder="$t('profile.sendMessage')"
                      />
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-12 mb-2">
                    <b-button
                      id="show-btn"
                      class="p-2 border-main"
                      @click="sendMessage"
                      :disabled="loading"
                    >
                      <span>{{ $t("profile.send") }}</span>
                      <span v-if="loading">
                        ...
                        <span>
                          <b-spinner label="Spinning" small></b-spinner>
                        </span>
                      </span>
                    </b-button>
                  </div>
                </div>
                <div class="error mt-2">
                  <p v-for="(error, index) in errors.message" :key="index">
                    {{ error }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="bv-modal-example" centered hide-footer>
        <template #modal-title> {{ $t("profile.quoteData") }} </template>
        <div class="d-block">
          <div class="data-holder">
            <div class="" v-if="quotations.product_supplier">
              <div class="" v-if="quotations.product_supplier.product">
                <div v-if="$i18n.locale == 'en'">
                  <h5 v-if="quotations.product_supplier.product">
                    {{ $t("profile.title") }} :
                    {{ quotations.product_supplier.product.title_en }}
                  </h5>
                </div>
                <div v-else>
                  <h5 v-if="quotations.product_supplier.product">
                    {{ $t("profile.title") }} :
                    {{ quotations.product_supplier.product.title_ar }}
                  </h5>
                </div>
              </div>

              <div class="" v-if="quotations.request_qty">
                <h5>
                  {{ $t("cart.quantity") }} : {{ quotations.request_qty }}
                </h5>
              </div>
              <div class="" v-if="quotations.expiry_at">
                <h5>
                  {{ $t("profile.expiry_at") }} : {{ quotations.expiry_at }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal id="bv-modal-example1" centered hide-footer>
        <template #modal-title> {{ $t("profile.yourMessage") }} </template>
        <div class="d-block">
          <div class="data-holder">
            <form>
              <textarea
                class="form-control"
                name=""
                id=""
                cols="30"
                rows="10"
                v-model="message"
                required
              ></textarea>
              <div class="error mt-2">
                <p v-for="(error, index) in errors.comment" :key="index">
                  {{ error }}
                </p>
              </div>
            </form>
          </div>
        </div>
        <b-button
          class="mt-3"
          variant="outline-success"
          block
          @click="sendMessage"
        >
          {{ $t("profile.send") }}
        </b-button>
      </b-modal>
      <b-modal id="bv-standingOrders" size="xl" hide-footer>
        <template #modal-title> {{ $t("items.standingOrders") }} </template>
        <standing-orders
          @customEmit="getClientStandingId($event)"
          :quotationQuantity="quotations.request_qty"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import profile from "@/services/profile";
import globalAxios from "@/services/global-axios";
import StandingOrders from "@/components/global/standingOrders.vue";
import spinner from "@/components/spinner.vue";

export default {
  data() {
    return {
      quotations: [], // Initialize as an empty array
      comments: [],
      id: this.$route.params.id,
      fields: [
        { key: "comments", label: this.$t("profile.sentBy") },
        {
          key: "supplier_product_name",
          label: this.$t("profile.quoteMessage"),
        },
        { key: "created_by", label: this.$t("profile.sentdate") },
      ],
      message: "",
      errors: [],
      client_standing_id: null,
      quotationQuantity: null,
      loading: false,
      storedQuotID: sessionStorage.getItem("currentQuotID"),
      hasRedirectedToStoredId: false,
      loadingMainData: false,
    };
  },
  computed: {
    // Computed property to sort comments
    sortedComments() {
      const sourceComments =
        (this.comments && this.comments.length && this.comments) ||
        (this.quotations && this.quotations.client_quote_comment) ||
        [];

      const getOrderValue = (comment = {}) => {
        if (typeof comment.order === "number") return comment.order;
        if (typeof comment.order_id === "number") return comment.order_id;
        if (comment.created_at) {
          const timeValue = new Date(comment.created_at).getTime();
          return Number.isNaN(timeValue) ? 0 : timeValue;
        }
        return 0;
      };

      return [...sourceComments].sort(
        (a, b) => getOrderValue(a) - getOrderValue(b)
      );
    },
    // Add currency from store
    currency() {
      return this.$store.state.currency?.currency || "USD";
    },
    // Check if add_to_cart is enabled
    // add_to_cart() {
    //   return this.$store.state.auth?.add_to_cart || false;
    // },
    // Check if the page is quotationDetails
    checkPage() {
      return this.$route.path.includes("quotationDetails");
    },
  },
  methods: {
    getQuotationDetail(id) {
      this.loadingMainData = true;
      profile
        .getQuotationDetail(id)
        .then((res) => {
          this.quotations = res.data.items.client_quote || [];
          const apiComments = res.data.items.comments || [];
          if (apiComments.length) {
            this.comments = apiComments;
          } else {
            this.comments =
              (this.quotations && this.quotations.client_quote_comment) || [];
          }
          // console.log("Quotation Details fetched:", this.quotations);
        })
        .catch((err) => {
          console.error("Error fetching quotation details:", err);
          this.quotations = []; // Reset on error
          this.comments = [];
        })
        .finally(() => {
          this.loadingMainData = false;
        });
    },
    addToCart() {
      let data = {
        client_quote_id: this.id,
        approve: 1,
      };
      return globalAxios
        .post(`members/product/rfq/approve`, data)
        .then((res) => {
          if (res.status == 200) {
            this.sucessMsg(res.data.message);
            document.querySelector(".close").click();
          }
        })
        .catch((error) => {
          const err = Object.values(error)[2]?.data || {};
          this.errors = err.items || [];
          this.errMsg(err.message || "Failed to add to cart");
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.dispatch("cart/getCartProducts");
          }, 500);
        });
    },
    sendMessage() {
      this.loading = true;
      let data = {
        client_quote_id: this.id,
        comment: this.message,
      };
      profile
        .sendMessage(data)
        .then((res) => {
          this.sucessMsg(res.data.message);
          document.querySelector(".close")?.click();
        })
        .catch((error) => {
          let err = Object.values(error)[2]?.data || {};
          this.errors = err.items || [];
        })
        .finally(() => {
          this.message = "";
          this.loading = false;
          this.getQuotationDetail(this.id);
        });
    },
    getClientStandingId(standId) {
      this.client_standing_id = standId;
    },
    initializeQuotationId() {
      const routeId = this.$route.params?.id;
      const storedId = sessionStorage.getItem("currentQuotID");

      if (!routeId && storedId && !this.hasRedirectedToStoredId) {
        this.hasRedirectedToStoredId = true;
        this.$router.replace({
          path: this.$route.path,
          params: { ...this.$route.params, id: storedId },
        });
      } else {
        this.id = routeId || storedId;
        if (this.id) {
          this.getQuotationDetail(this.id);
        }
      }
    },
    sucessMsg(message) {
      this.$bvToast.toast(message, {
        title: "Success",
        variant: "success",
        solid: true,
      });
    },
    errMsg(message) {
      this.$bvToast.toast(message, {
        title: "Error",
        variant: "danger",
        solid: true,
      });
    },
    /**
     * Decode numeric HTML entities so backend comments like `&#36;` show `$`
     * while keeping the rest of the HTML markup (e.g. <br/>) intact.
     */
    decodeComment(comment) {
      if (!comment) return "";
      const decodeNumericEntity = (match, code) => {
        const parsedCode = parseInt(code, 10);
        return Number.isNaN(parsedCode)
          ? match
          : String.fromCharCode(parsedCode);
      };
      const decodeHexEntity = (match, code) => {
        const parsedCode = parseInt(code, 16);
        return Number.isNaN(parsedCode)
          ? match
          : String.fromCharCode(parsedCode);
      };

      return comment
        .replace(/&#x([0-9a-fA-F]+);/g, decodeHexEntity)
        .replace(/&#([0-9]+);/g, decodeNumericEntity);
    },
  },
  mounted() {
    // console.log("QuotationDetails mounted with ID:", this.id);
    this.initializeQuotationId();
  },
  components: {
    StandingOrders,
    spinner,
  },
  metaInfo: {
    title: "quotation details page",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: `${localStorage.getItem("lang")}`,
      amp: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.ar {
  thead th {
    text-align: right !important;
  }
}

.en {
  thead th {
    text-align: left !important;
  }
}

.comment {
  word-break: break-all;
}

.custom-margin {
  margin-bottom: 80px;
}

.new-design {
  ul.chat {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    width: 70%;
    max-height: 500px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      -webkit-box-shadow: inset 0 0 6px $main-color;
    }

    @media (max-width: 992px) {
      width: 100%;
    }

    p {
      margin-bottom: 10px;
      display: inline-block;
      border-radius: 8px;
      padding: 10px;
      width: 50%;
      min-height: 90px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .left {
      background: #e3e3e3;
      width: 100%;
      border-top-left-radius: 0;
      border-radius: 30px 30px 30px 0;
    }

    .right {
      background: transparent;
      border: 2px solid #e3e3e3;
      border-top-right-radius: 0;
      width: 100%;
      border-radius: 30px 30px 0px 30px;
    }

    &.stamp {
      color: #666;
      font-size: 80%;
      text-align: center;
      width: 100%;

      span {
        color: #999;
      }
    }
  }
}

.en .chat,
.ar .chat {
  direction: ltr !important;
}

.ar .chat {
  text-align: right !important;
}

li {
  p {
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
  }
}

.sendMessageHolder {
  width: 70%;
  margin: auto;

  button {
    height: 53px;
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;

    .row {
      text-align: center;

      button {
        width: 50%;
        margin: auto;
      }
    }
  }
}

.left,
.right {
  position: relative;

  .message {
    margin-bottom: 20px;
  }

  .messageDate {
    position: absolute;
    right: 15px;
    bottom: 5px;
    opacity: 0.5;
  }
}

.company-logo {
  .data-holder {
    width: 40%;
  }

  button {
    height: 20px;
    width: 20px;
    line-height: 20px;
    border: none;
  }

  .file-wrapper {
    text-align: center;
    height: 20px;
    vertical-align: middle;
    position: absolute;
    right: 35px;
    top: -5px;
    font-size: 20px;
  }

  .file-wrapper input {
    position: absolute;
    top: 5px;
    right: -12px;
    cursor: pointer;
    opacity: 0;
    filter: alpha(opacity=0);
    height: 50px;
    cursor: pointer;
  }

  .file-input {
    color: $top-header-color;
  }

  .text-holder {
    color: #bebebe;
    margin: 20px 0;
    cursor: pointer;
  }
}

.myIcon {
  cursor: pointer;
}

.message-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  cursor: pointer;

  img {
    cursor: pointer;
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}

.withdrow-image {
  max-height: 50vh;
  width: 100%;
  object-fit: contain;
}
</style>
